exports.en = {
  BUTTON_CHAT: {
    EMAIL: 'at'
  }
}
